<template lang="pug">
  #top
    p#title-text {{ $t("top.title") }}
    h4 〜 Stay Home, Save Lives, and Type Well 〜
    h5#challenger-count {{ $t("top.total-play-count") }}: {{ totalPlayCount.toLocaleString() }}
    h5#challenger-count {{ $t("top.total-type-count") }}: {{ totalTypeCount.toLocaleString() }}
    v-card.game-explanation-area
      .game-explanation
        v-card-title {{ $t("top.game-explanation.title") }}
        v-card-text
          p {{ $t("top.game-explanation.item-1") }}
          p {{ $t("top.game-explanation.item-2") }}
          p {{ $t("top.game-explanation.item-3") }}
          p {{ $t("top.game-explanation.item-4") }}
          p {{ $t("top.game-explanation.item-5") }}
      .game-start-btn-area
        .image-area
          img.irasutoya-img(src='/static/images/computer_suit_woman.png')
          img.irasutoya-img(src='/static/images/computer05_businessman.png')
        v-card-subtitle {{ $t("top.recommendation.title") }}
        v-card-text
          span &nbsp;&nbsp;{{ $t("top.recommendation.content.title-browser") }}:
          span.warning-text {{ $t("top.recommendation.content.content-browser") }}
        router-link.game-start-btn(v-bind:to="'/game'")
          v-btn(x-large block rounded color="primary" dark) {{ $t("top.game-start-btn-text") }}
    div#additional-area
      v-card.additional-area-card(v-if="resultRankData.length > 0")
        rank-graph-component(:chartData="vueChartData" :options="options")
      v-card.additional-area-card
        v-card-title {{ $t("top.developers-thought.title") }}
          v-card-text
            p {{ $t("top.developers-thought.content.item-1") }}
            p {{ $t("top.developers-thought.content.item-2") }}
            p {{ $t("top.developers-thought.content.item-3") }}
          #developer-intro
            img.irasutoya2-img(src='/static/images/computer_man1_smile.png')
            #intro
              v-card-text
                p T.Kai
                p Email: type.to.live.tkai@gmail.com
                span Twitter:
                a(target='_blank' href="https://twitter.com/youkinaengineer") @youkinaengineer

</template>

<script>

import { mapActions, mapState } from 'vuex'
import RankGraphComponent from '@/components/RankGraph'

export default {
  data: function () {
    return {
      vueChartData: null,
      options: null
    }
  },
  components: {
    RankGraphComponent
  },
  computed: {
    ...mapState({
      resultState: state => state.Result
    }),
    resultRankData: function () {
      const labels = this.resultState.resultRankData.map((stat) => {
        return stat['rank']
      })
      const values = this.resultState.resultRankData.map((stat) => {
        return stat['count']
      })
      // eslint-disable-next-line
      this.vueChartData = {
        maintainAspectRatio: true,
        repsonsive: true,
        labels: labels,
        datasets: [
          {
            type: 'bar',
            label: this.$t('top.rank-chart.title'),
            backgroundColor: '#f87979',
            data: values
          }
        ]
      }
      // eslint-disable-next-line
      this.options = {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
      return this.resultState.resultRankData
    },
    totalPlayCount: function () {
      return this.resultState.totalPlayCount
    },
    totalTypeCount: function () {
      return this.resultState.totalTypeCount
    }
  },
  created: function () {
    this.subscribeAggregation()
  },
  methods: {
    ...mapActions({
      subscribeAggregation: 'Result/subscribeAggregations'
    })
  }
}

</script>

<style>

#title-text {
  font-size: 30px;
  font-weight: bold;
}

#challenger-count {
  margin-top: 7px;
}

.game-explanation-area {
  text-align: left;
  margin-top: 20px;
  padding: 20px;
  width: 100%;
  display: inline-flex !important;
}

.game-explanation {
  width: 60%;
}

.game-start-btn-area {
  width: 30%;
}

.warning-text {
  text-decoration: underline;
  text-decoration-color: red;
}

.irasutoya-img {
  width: 30%;
}

#developer-intro {
  display: inline-flex;
}

.irasutoya2-img {
  width: 30%;
}

#additional-area {
  width: 100%;
  display: inline-flex;
}

.additional-area-card {
  text-align: left;
  margin: 20px 5px 0px 5px;
  padding: 20px;
  width: 50%;
}

@media screen and (max-width: 640px){
  #title-text {
    font-size: 20px;
    font-weight: bold;
  }

  .game-explanation-area {
    text-align: left;
    margin-top: 20px;
    padding: 20px;
    width: 100%;
    flex-direction: column;
  }

  /*ここにどんどん追記していきます！*/
  .game-explanation {
    width: 100%;
  }

  .game-start-btn-area {
    width: 100%;
  }

  #additional-area {
    width: 100%;
    flex-direction: column;
  }

  .additional-area-card {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Top.vue